/**
 * Status Badge Component
 * Reusable status indicator with color coding
 * Extracted from multiple components to eliminate duplication
 */

import React from 'react';

/**
 * Status Badge Component
 *
 * @param {Object} props - Component props
 * @param {string} props.label - Badge label
 * @param {string} props.variant - Badge variant ('success', 'error', 'warning', 'info', 'neutral')
 * @param {Object} props.style - Additional styles
 * @param {string} props.size - Badge size ('small', 'medium', 'large')
 */
const StatusBadge = ({
    label,
    variant = 'neutral',
    style = {},
    size = 'medium'
}) => {
    const variants = {
        success: {
            backgroundColor: '#27ae60',
            color: '#ffffff'
        },
        error: {
            backgroundColor: '#e74c3c',
            color: '#ffffff'
        },
        warning: {
            backgroundColor: '#f59e0b',
            color: '#ffffff'
        },
        info: {
            backgroundColor: '#3498db',
            color: '#ffffff'
        },
        neutral: {
            backgroundColor: '#6c757d',
            color: '#ffffff'
        },
        healthy: {
            backgroundColor: '#27ae60',
            color: '#ffffff'
        },
        unhealthy: {
            backgroundColor: '#e74c3c',
            color: '#ffffff'
        }
    };

    const sizes = {
        small: {
            padding: '0.25rem 0.5rem',
            fontSize: '0.7rem'
        },
        medium: {
            padding: '0.35rem 0.75rem',
            fontSize: '0.8rem'
        },
        large: {
            padding: '0.5rem 1rem',
            fontSize: '0.9rem'
        }
    };

    const baseStyle = {
        display: 'inline-block',
        borderRadius: '12px',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        whiteSpace: 'nowrap',
        ...sizes[size],
        ...variants[variant],
        ...style
    };

    return (
        <span style={baseStyle}>
            {label}
        </span>
    );
};

export default StatusBadge;

